// The host half of the shared Add Custom Field popup island (#19714,
// app/frontend/react/mountAddCustomFieldModal.tsx). A Stimulus controller that
// hosts the island (Settings → Custom Fields, Import Leads' Map step) keeps one
// of these: the bridge mounts the island asynchronously, so an Add click that
// lands before the island listens is held and delivered on its `ready` event,
// never lost and never sent twice.
export const ADD_CUSTOM_FIELD_OPEN_EVENT = "add-custom-field:open"

export class AddCustomFieldIsland {
  constructor () {
    this.element = null
    this.pending = null
  }

  // add-custom-field:ready — the island listens now; deliver a held open.
  ready (element) {
    this.element = element
    if (!this.pending) return
    const detail = this.pending
    this.pending = null
    this.#dispatch(detail)
  }

  // Opens the popup, `detail.name` prefilling Field Name.
  open (detail = {}) {
    if (this.element) this.#dispatch(detail)
    else this.pending = detail
  }

  #dispatch (detail) {
    this.element.dispatchEvent(new CustomEvent(ADD_CUSTOM_FIELD_OPEN_EVENT, { detail }))
  }
}
